import React, { Component } from "react";
import { ENQUIRE_LINK, PLANNER_BOOK_TEXT } from "./utils/constants";
import { TOGGLE_BASKET } from "./utils/events";

class SuccessPopup extends Component {
    state = {
        active: false,
        panel: null,
    };

    componentDidMount() {
        document.addEventListener(TOGGLE_BASKET, this.toggleBasket.bind(this));
    }

    render() {
        const { active, panel } = this.state;
        console.log("panel", panel);

        if (!active || !panel) return null;

        return (
            <div className="planner-popup__bg">
                <div className="planner-popup">
                    <div
                        className="planner-popup__close"
                        onClick={this.handleClose.bind(this)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewbox="0 0 30 30"
                        >
                            <g fill="currentColor" fill-rule="evenodd">
                                <path d="M.7071 2.5821 27.418 29.293c.3905.3905 1.0237.3905 1.4142 0l.4608-.4608c.3905-.3905.3905-1.0237 0-1.4142L2.582.707c-.3905-.3905-1.0237-.3905-1.4142 0l-.4608.461c-.3905.3905-.3905 1.0237 0 1.4142Z" />
                                <path d="M.7071 27.4179 27.418.707c.3905-.3905 1.0237-.3905 1.4142 0l.4608.4608c.3905.3905.3905 1.0237 0 1.4142L2.582 29.293c-.3905.3905-1.0237.3905-1.4142 0l-.4608-.461c-.3905-.3905-.3905-1.0237 0-1.4142Z" />
                            </g>
                        </svg>
                    </div>
                    {/*todo: we need to add the icon which was in the initial design?*/}
                    {/*<h4 className="planner-popup__icon">Success</h4>*/}
                    <p className="planner-popup__content">
                        Great! This site has been added to your list.
                    </p>
                    <div className="planner-popup_actions">
                        <button
                            className="button"
                            onClick={this.handleClose.bind(this)}
                        >
                            Add another site
                        </button>
                        <a href={ENQUIRE_LINK} className="button">
                            Submit enquiry
                        </a>
                    </div>
                    {panel.type === 'DigitalBillboard' || panel.type === 'Air' ? (
                        <div className="planner-popup__book">
                            <div className="planner-popup__book-text">
                                <p>{PLANNER_BOOK_TEXT}</p>
                            </div>
                            <div className="planner-popup__book-button">
                            <a target="_blank" href="https://diybillboards.co.nz" className="button">
                                Book now
                                </a>        
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }

    toggleBasket(e) {
        const { panel, added } = e.data;
        this.setState({ active: added, panel });
    }

    handleClose() {
        this.setState({
            active: false,
            panel: null,
        });
    }
}

export default SuccessPopup;
